import {loqateKey} from './config';

export const options = {
  key: loqateKey,
  GeoLocationEnabled: true,
  GeoLocationRadius: 100,
  GeoLocationMaxItems: 10,
  manualEntryItem:true,
};
